import { render } from "./dealer_registration.vue?vue&type=template&id=353c18ea&scoped=true"
import script from "./dealer_registration.vue?vue&type=script&lang=js"
export * from "./dealer_registration.vue?vue&type=script&lang=js"

import "./dealer_registration.vue?vue&type=style&index=0&id=353c18ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353c18ea"]])

export default __exports__